import { c as _c } from "react/compiler-runtime";
import MuiLinearProgress, { LinearProgressProps as MuiLinearProgressProps } from '@mui/material/LinearProgress';
import { CSSObject, SxProps, Theme, styled } from '../styles';
export const SIZES = {
  NORMAL: 'normal',
  BIG: 'big'
};
type LinearProgressSize = 'default' | 'large';
type LinearProgressShape = 'default' | 'rounded';
export interface Props extends MuiLinearProgressProps {
  maxValue: number;
  shape?: LinearProgressShape;
  value: number;
  expectedValue?: number;
  size?: LinearProgressSize;
  isDisabled?: boolean;
  'aria-label'?: string;
  sx?: SxProps<Theme>;
}
function getPercent(value: number, maxValue: number) {
  return Math.min(100, Math.round(value * 100 / maxValue));
}
const LinearProgressStyled = styled(MuiLinearProgress, {
  shouldForwardProp: prop => !['size', 'shape', 'isDisabled'].includes(prop as string)
})<{
  size: LinearProgressSize;
  shape: LinearProgressShape;
  isDisabled: boolean;
  value: number;
}>(({
  theme: {
    palette
  },
  size,
  shape,
  isDisabled,
  value
}) => {
  const styles: Record<LinearProgressSize, CSSObject> = {
    default: {
      height: 4,
      '&, & > span': {
        height: 4
      }
    },
    large: {
      height: 8,
      '&, & > span': {
        height: 8
      }
    }
  };
  return {
    position: 'relative',
    '&': {
      overflow: 'hidden',
      ...(shape === 'rounded' && {
        borderRadius: 4
      }),
      ...(value < 100 && {
        '& span': {
          borderTopRightRadius: 4,
          borderBottomRightRadius: 4
        }
      })
    },
    ...styles[size],
    '&.MuiLinearProgress-root': {
      backgroundColor: isDisabled ? palette.progress.completion.disabled.enabled : palette.progress.completion.enabled,
      zIndex: 'initial'
    },
    '& .MuiLinearProgress-bar': {
      backgroundColor: isDisabled ? palette.progress.completion.disabled.active : palette.progress.completion.active,
      zIndex: 10
    }
  };
});
const LinearProgress = t0 => {
  const $ = _c(24);
  let ariaLabel;
  let maxValue;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      shape: t1,
      maxValue,
      size: t2,
      "aria-label": ariaLabel,
      isDisabled: t3,
      variant: t4,
      sx: t5,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = ariaLabel;
    $[2] = maxValue;
    $[3] = otherProps;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = value;
  } else {
    ariaLabel = $[1];
    maxValue = $[2];
    otherProps = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    value = $[9];
  }
  const shape = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "default" : t2;
  const isDisabled = t3 === undefined ? false : t3;
  const variant = t4 === undefined ? "determinate" : t4;
  let t6;
  if ($[10] !== t5) {
    t6 = t5 === undefined ? {} : t5;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const sx = t6;
  let t7;
  if ($[12] !== maxValue || $[13] !== value) {
    t7 = getPercent(value, maxValue);
    $[12] = maxValue;
    $[13] = value;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const percent = t7;
  let t8;
  if ($[15] !== ariaLabel || $[16] !== isDisabled || $[17] !== otherProps || $[18] !== percent || $[19] !== shape || $[20] !== size || $[21] !== sx || $[22] !== variant) {
    t8 = <LinearProgressStyled aria-label={ariaLabel} variant={variant} shape={shape} value={percent} size={size} isDisabled={isDisabled} sx={sx} {...otherProps} />;
    $[15] = ariaLabel;
    $[16] = isDisabled;
    $[17] = otherProps;
    $[18] = percent;
    $[19] = shape;
    $[20] = size;
    $[21] = sx;
    $[22] = variant;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
export default LinearProgress;